import { FC } from "react";
import classNames from "classnames";

import { DialogContent } from "components/DialogContent/DialogContent";
import { MediumText } from "components/MediumText/MediumText";

import { setModalCloseAtom } from "../../atoms/modalAtom/modalAtom";

import styles from "./styles.module.css";

export type LoadingModalProps = {
  height?: number;
  atomToOpen?: any;
  setAtomClose?: any;
};

export const LoadingModal: FC<LoadingModalProps> = ({
  height,
  setAtomClose = setModalCloseAtom,
}): JSX.Element => {
  return (
    <DialogContent
      className={classNames(styles.dialog, "flex items-center flex-col")}
      style={{ height: height ? `${height}px` : undefined }}
      setAtomClose={setAtomClose}
    >
      <MediumText size={20}>Загрузка...</MediumText>
    </DialogContent>
  );
};
